import { graphql, Link, useStaticQuery } from 'gatsby';
import React, { ReactElement } from 'react';
import Text from '../../../../type/text';

/*
  The sticky category sidebar. blog-nav and the press-releases page render the
  same markup, so the classes live here rather than being copied three times —
  they used to share the `.support-nav` rules in style.css.

  800px stays literal: `md` is 768px, and snapping there would flip the layout
  at exactly the iPad-portrait width.
*/
export const SUPPORT_NAV =
  'support-nav flex min-w-78.75 flex-col pt-20 max-[800px]:-mx-4 max-[800px]:mb-8 max-[800px]:border-r-0 max-[800px]:border-b max-[800px]:border-neutral-gray-100 max-[800px]:pt-0 max-[800px]:pl-2 [&_a]:mb-5 [&_a]:inline-flex [&_a]:h-8 [&_a]:items-center [&_a]:rounded-md [&_a]:border-2 [&_a]:border-transparent [&_a]:px-2 [&_a]:text-type-blue [&_a]:no-underline [&_a]:transition-[border] [&_a]:duration-200 [&_a]:ease-[ease] max-[800px]:[&_a]:mb-0 max-[800px]:[&_a]:h-auto [&_a.support-nav--active]:border-base-purple-500 [&_a.support-nav--active]:text-base-purple-500 [&_a:hover]:border-base-purple-500 [&_a:hover]:text-base-purple-500 max-[800px]:[&_a:not(:last-child)]:pl-0';

export const SUPPORT_NAV_CONTAINER =
  'support-nav__container sticky top-12 max-[800px]:grid max-[800px]:grid-cols-2 max-[800px]:justify-center max-[800px]:gap-x-8 max-[800px]:gap-y-4 max-[800px]:py-4 max-[380px]:grid-cols-1 max-[800px]:[&_.list--nav]:border-b-4 max-[800px]:[&_.list--nav]:border-transparent';

// The left side navigation for all of the /support pages.
// Add categories to the /src/content/support-categories file
// to have them show up in the nav.
export default function SupportNav(): ReactElement {
  const data = useStaticQuery(graphql`
    query MyQuery {
      allStrapiSupportCategory(sort: { priority: ASC }) {
        nodes {
          slug
          name
        }
      }
    }
  `);

  return (
    <nav className={SUPPORT_NAV} aria-label="Support category navigation">
      <div className={SUPPORT_NAV_CONTAINER}>
        {data.allStrapiSupportCategory.nodes.map(({ name, slug }) => {
          return (
            <Text level="semibold" key={slug}>
              <Link
                to={`/support/${slug}/`}
                activeClassName="support-nav--active"
                partiallyActive>
                {name}
              </Link>
            </Text>
          );
        })}

        <Text level="semibold">
          <Link to="/support/privacy/" activeClassName="support-nav--active">
            Privacy
          </Link>
        </Text>

        <Text level="semibold">
          <Link to="/support/contact-us/" activeClassName="support-nav--active">
            Contact Us
          </Link>
        </Text>
      </div>
    </nav>
  );
}
